import type { ReactNode } from 'react';
import type { HintData } from '@/api/gen/_model/hintData';
import { QuizCard } from '@/shared/components/QuizCardV2';
import type { HintType } from '@/shared/components/QuizCardV2/types';
import { cn } from '@/utils/tailwind.util';
const ANSWER_REVEAL_ANIMATION = 'animate-in fade-in-0 duration-200 motion-reduce:animate-none';

/** 정답 영역 래퍼. 표시로 바뀔 때만 페이드인하고 숨길 때는 즉시 가린다. */
export const AnswerSection = ({
  isAnswerHidden,
  notice,
  children
}: {
  isAnswerHidden: boolean;
  notice?: ReactNode;
  children?: ReactNode;
}) => {
  if (!notice && !children) return null;
  return <div className={cn('flex flex-col gap-2xs', !isAnswerHidden && ANSWER_REVEAL_ANIMATION)} data-sentry-component="AnswerSection" data-sentry-source-file="AnswerSection.tsx">
      {notice}
      {children}
    </div>;
};

/** 힌트도 정답을 드러낼 수 있어 정답 영역과 함께 숨기고 드러낸다. */
export const AnswerHint = ({
  hint,
  isAnswerHidden
}: {
  hint?: HintData;
  isAnswerHidden: boolean;
}) => {
  if (isAnswerHidden || !hint?.value) return null;
  return <QuizCard.Hint type={hint.type as HintType} value={hint.value} className={ANSWER_REVEAL_ANIMATION} data-sentry-element="unknown" data-sentry-component="AnswerHint" data-sentry-source-file="AnswerSection.tsx" />;
};